import { render, staticRenderFns } from "./ChangePhoneForm.vue?vue&type=template&id=3c2fd4dc&scoped=true&"
import script from "./ChangePhoneForm.vue?vue&type=script&lang=js&"
export * from "./ChangePhoneForm.vue?vue&type=script&lang=js&"
import style0 from "./ChangePhoneForm.vue?vue&type=style&index=0&id=3c2fd4dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2fd4dc",
  null
  
)

export default component.exports